type EventName = typeof Name;

export const Name = 'open-login';
export const OpenLogin: EventName = Name;

export interface Data {}

export interface Event extends CustomEvent<Data> {
  /** Name of event */
  type: EventName;
}

export default Event;
